import { VStack } from "goi_common";
import { ParlorMap } from "@/containers/ContactContainer/ContactAddContainer/components/ParlorMap";
import { useGetObituary } from "../../BugoCreateContainer/hooks/useGetObituary";
import { BugoSection } from "../../BugoCreateContainer/components/BugoSection";

export const BugoDetailParlorMap = () => {
  const { data, isLoading } = useGetObituary();

  return (
    <BugoSection title="오시는 길">
      <VStack gap="8px">
        <ParlorMap
          parlor={data?.parlor}
          description={
            !isLoading && !data?.parlor?.address
              ? "빈소 정보를 입력하시면\n아래 지도 정보가 자동으로 만들어집니다."
              : undefined
          }
        />
      </VStack>
    </BugoSection>
  );
};
